import getMadaiURL from '../domain/getMadaiURL';
import get_bundle from '../domain/get_bundle';

const madai_url = getMadaiURL();

export default function getPolicy(locale) {
  function getHref() {
    return "https://madai.com/faq_us.html"
    /*const _locale = locale.toString();
    const country = locale.country.toLowerCase();
    if (_locale === 'en_ZA') {
      return 'http://za.shop.madai.com/privacy-policy_en.html';
    } else if (_locale === 'en_US') {
      return 'http://us.shop.madai.com/privacy-policy_en.html';
    } else if (_locale === 'it_IT') {
      return 'http://it.madai.com/privacy-policy_IT.html';
    }
    else {
      return madai_url + country + '/privacy.html';
    }*/
  }
  return '<a target="_blank" href="' + getHref() + '">' + get_bundle(locale).footer.policy + '</a>';
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/util/getPolicy.js
 **/